import React, { useState } from "react";
import Error from "../Error";
import MdTrash from "react-ionicons/lib/MdTrash";

import ModalDelete from "../../common/ModalDelete";

const DriverForm = ({
  driverIndex,
  register,
  name,
  email,
  id,
  errors,
  deletedDrivers,
  setDeletedDrivers,
  removeDriver,
}) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  var subtitle;

  const remove = () => {
    if (!id.includes("-")) {
      const prev = deletedDrivers;
      prev.push(id);
      setDeletedDrivers(prev);
    }
    removeDriver(driverIndex);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div className="px-8 py-4 bg-white rounded-md relative mb-4 border-2 border-gray-200">
      <input
        className="hidden"
        type="text"
        name={`drivers[${driverIndex}].id`}
        ref={register()}
        defaultValue={id}
      />
      <MdTrash onClick={openModal} className="trash"></MdTrash>
      <ModalDelete
        message="¿Estás seguro que quieres borrar los datos del repartidor?
                    Todos los datos serán perdidos permanentemente. Esta acción
                    no se puede revertir."
        closeModal={closeModal}
        modalIsOpen={modalIsOpen}
        remove={remove}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        subtitle={subtitle}
        title="Borrar repartidor"
      ></ModalDelete>
      <div className="w-full">
        <div className="mb-4 w-full input">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor={`drivers[${driverIndex}].name`}
          >
            Nombre
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            name={`drivers[${driverIndex}].name`}
            ref={register()}
            defaultValue={name}
            placeholder="Nombre del repartidor"
          />
          <Error error={errors ? errors.name : null} left></Error>
        </div>
        <div className="mb-4 w-full input">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor={`drivers[${driverIndex}].email`}
          >
            Correo electrónico
          </label>
          <input
            className={
              id.includes("-")
                ? "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                : "shadow appearance-none rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline bg-gray-200"
            }
            type="text"
            name={`drivers[${driverIndex}].email`}
            ref={register()}
            defaultValue={email}
            placeholder="Correo electrónico"
            disabled={id.includes("-") ? false : true}
          />
          <Error error={errors ? errors.email : null} left></Error>
        </div>
        <div className="mb-4 w-full input">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor={`drivers[${driverIndex}].password`}
          >
            Contraseña
          </label>
          <input
            className={
              id.includes("-")
                ? "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                : "shadow appearance-none rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline bg-gray-200"
            }
            type="password"
            name={`drivers[${driverIndex}].password`}
            ref={register()}
            placeholder="Contraseña del repartidor"
            disabled={id.includes("-") ? false : true}
            defaultValue={id.includes("-") ? "" : "1234567890"}
          />
          <Error error={errors ? errors.password : null} left></Error>
        </div>
      </div>
    </div>
  );
};

export default DriverForm;
